export const metaKeywords:string[]=[
    "pravinbhati.com, pravinbhati.in, www.pravinbhati.com, www.pravinbhati.in, pravinbhati.org",
    "pravin, bhati, pravinbhati, pravin bhati, pravin kanaram bhati",
    "software, engineer, software engineer, full stack developer, fullstackdeveloper, web developer",
    "angular, django, rest framework, django rest framework, angular13, java, python, C, C programming, c++, mysql, sql, database, data structure",
    "MTS, Marthoma, SRP, Swami, Ramkrishna, PVPP, PVPPCOE, VPPCOE, Vasantdada, School, College, Chembur, Govandi, Mumbai, India",
    "Portfolio, Freelancer, Student, Information Technology, computer science, web app, tcs, employee"
]